import { API_CONSTANT_MAP } from "./paths";
import requestApi from "./requestApi";

export type GetDinheirosFiltro = {
  recolhido?: boolean;
  dataInicio?: string;
  dataFim?: string;
  unidadeIds?: number[];
  busca?: string;
};

export const getDinheiros = async (filtro?: GetDinheirosFiltro) => {
  const params = new URLSearchParams();
  if (filtro?.recolhido !== undefined) params.append("recolhido", String(filtro.recolhido));
  if (filtro?.dataInicio) params.append("dataInicio", filtro.dataInicio);
  if (filtro?.dataFim) params.append("dataFim", filtro.dataFim);
  filtro?.unidadeIds?.forEach((u) => params.append("unidadeIds", String(u)));
  if (filtro?.busca) params.append("busca", filtro.busca);

  const query = params.toString();
  const url = query ? `${API_CONSTANT_MAP.dinheiro}?${query}` : API_CONSTANT_MAP.dinheiro;
  return requestApi.get(url);
};

export const recolherDinheiros = (ids: number[]) => {
  return requestApi.put(`${API_CONSTANT_MAP.dinheiro}/recolher`, { ids });
};
